import API from "../services/api";
import toast from "react-hot-toast";

function sanitizeFileNamePart(value) {
  if (!value) return "";
  return String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export function buildResumeFileName(candidate = {}) {
  const first = sanitizeFileNamePart(candidate.firstname);
  const last = sanitizeFileNamePart(candidate.lastname);
  if (first || last) return `${[first, last].filter(Boolean).join("_")}.pdf`;
  const full = sanitizeFileNamePart(candidate.candidate_name || candidate.name);
  return `${full || "CV"}.pdf`;
}

export async function downloadResume(candidate) {
  const userId = typeof candidate === "string" ? candidate : candidate?.candidate_id || candidate?._id;
  if (!userId) return;
  try {
    const { blob, fileName: headerName } = await API.downloadFile(`/user/${userId}/resume?download=1`);
    const fallback = typeof candidate === "object" ? buildResumeFileName(candidate) : "CV.pdf";
    const fileName = (headerName && headerName !== "CV.pdf" ? headerName : fallback) || "CV.pdf";
    // octet-stream so the browser saves the file instead of opening the PDF viewer
    const file = new Blob([blob], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (e) {
    console.error("Error downloading resume:", e);
    toast.error("Failed to download resume");
  }
}

export function timeSince(date) {
  var seconds = +Math.floor((new Date() - new Date(date)) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " year";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " month";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " h";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " min";
  }
  return Math.floor(seconds) + " sec";
}

export const readFileAsync = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const slugify = (value) => {
  const a = "àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;";
  const b = "aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------";
  const p = new RegExp(a.split("").join("|"), "g");
  return value
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, "-and-") // Replace & with 'and'
    .replace(/[^\w\-]+/g, "") // Remove all non-word characters
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
};
